import { Component, EventEmitter, HostBinding, OnDestroy, OnInit, Output } from '@angular/core';
import { RealTimeContextService } from 'app/real-time/real-time-context.service';
import {
  PLATES_EXCEPTIONS_LINKS,
  PLATES_EXCEPTIONS_SER_PARKING,
  PLATES_RESTRICTIONS_CODE,
  PLATES_TEXT_SQL,
  SER_PARKING_NO_ALL,
  SER_PARKING_NO_WITH_RESTRICTIONS,
  SER_PARKING_WITHOUT_RESTRICTIONS,
  VEHICLE_B,
  VEHICLE_C,
  VEHICLE_CERO,
  VEHICLE_ECO,
  VEHICLE_ERROR,
  VEHICLE_NOTAG
} from '../informo.const';
import { InformoService } from '../informo.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'informo-plates-searcher',
    templateUrl: './plates-searcher.component.html',
    styleUrls: ['./plates-searcher.component.scss']
})
export class PlatesSearcherComponent implements OnInit, OnDestroy {
    private plateType;
    @Output() onPlate = new EventEmitter();
    @HostBinding('class.with-alert') alertLevel;
    @HostBinding('class.collapse') collapse = true;
    message;
    link;
    serRestrictions;
    public plate: string;


    constructor(
        private realtimeContextService: RealTimeContextService,
        private informoService: InformoService
    ) {
    }

    ngOnInit() {
        (<HTMLElement>document.querySelector('app-real-time-menu')).style.display = 'none';
        document.querySelector('informo-real-time-legend').classList.add('hidden');
          this.informoService.getAlertLevel.subscribe(async level => {
            this.alertLevel = level || 1;
            if (this.plateType !== undefined) {
                this.message = await this.getVehicleTypeMessage(this.plateType, this.alertLevel);
                this.serRestrictions = await this.getSerRestriction(this.plateType, this.alertLevel);
                this.link = PLATES_EXCEPTIONS_LINKS[this.plateType] || null;
              }
          });
    }

    async searchPlate() {
      const info = await this.informoService.searchPlate(this.plate).toPromise();
      this.plateType = info.tipo;
      this.message = await this.getVehicleTypeMessage(this.plateType, this.alertLevel);
      this.serRestrictions = await this.getSerRestriction(this.plateType, this.alertLevel);
      this.link = PLATES_EXCEPTIONS_LINKS[this.plateType] || null;
      this.onPlate.emit({plateType: this.plateType, alertLevel: this.alertLevel});
    }

    togglePlatesForm() {
        this.collapse = !this.collapse;
    }

    getSerRestriction(plateType, scenario = 0) {
      let restrictionsLevel = null;
      if (plateType >= VEHICLE_ERROR) {
        // Plate doesn't exist
        return null;
      }
      if (
        (plateType === VEHICLE_NOTAG && scenario >= 1)
        || (plateType === VEHICLE_B && scenario < 4)
        || plateType === VEHICLE_C
      ) {
        restrictionsLevel = SER_PARKING_NO_WITH_RESTRICTIONS;
      } else if (
        (plateType === VEHICLE_B || plateType === VEHICLE_ECO)  && scenario === 5
      ) {
        restrictionsLevel = SER_PARKING_NO_ALL;
      } else if (plateType === VEHICLE_ECO || plateType === VEHICLE_CERO || scenario === 1) {
        restrictionsLevel = SER_PARKING_WITHOUT_RESTRICTIONS;
      }
      return restrictionsLevel && PLATES_EXCEPTIONS_SER_PARKING[restrictionsLevel] || null
    }

    async getVehicleTypeMessage(type, scenario) {
        let code = PLATES_RESTRICTIONS_CODE.ERROR;

        if (scenario < 3 && type === VEHICLE_NOTAG) {
          code = PLATES_RESTRICTIONS_CODE.INSIDE_M30;
        } else if (scenario === 3 && type === VEHICLE_NOTAG) {
          code = PLATES_RESTRICTIONS_CODE.SCENARIO_3;
        } else if (scenario === 4 && type === VEHICLE_NOTAG) {
          code = PLATES_RESTRICTIONS_CODE.SCENARIO_4_ALL;
        } else if (scenario === 5 && type === VEHICLE_NOTAG) {
          code = PLATES_RESTRICTIONS_CODE.SCENARIO_5_ALL;
        } else if (scenario < 4 && type === VEHICLE_B) {
          code = PLATES_RESTRICTIONS_CODE.ONLY_ZBEDEP_CENTRO;
        } else if (scenario === 4 && type === VEHICLE_B) {
          code = PLATES_RESTRICTIONS_CODE.SCENARIO_4_M30;
        } else if (scenario === 5 && type === VEHICLE_B) {
          code = PLATES_RESTRICTIONS_CODE.SCENARIO_5_ALL;
        } else if (scenario < 5 && type === VEHICLE_C) {
          code = PLATES_RESTRICTIONS_CODE.ONLY_ZBEDEP_CENTRO;
        } else if (scenario === 5 && type === VEHICLE_C) {
          code = PLATES_RESTRICTIONS_CODE.SCENARIO_5_ALL;
        } else if (type === VEHICLE_CERO || type === VEHICLE_ECO) {
          code = PLATES_RESTRICTIONS_CODE.NO_RESTRICTION;
        }

        try {
          const url = environment.carto.apiBaseUrl + environment.carto.sqlEndpoint

          const urlWithParams = addQueryParams(url, {
            q: PLATES_TEXT_SQL,
            queryParameters: JSON.stringify({ code })
          });

          const body = {
              headers: {
                  'Authorization': 'Bearer ' + environment.carto.accessToken
              },
          }

          const response = await fetch(urlWithParams, body)
          const toJson = await response.json()

          if (toJson) {
            return toJson.rows[0].descripcion;
          }

          return ''
      } catch (err) {
          console.error(`Error fetching sql data: ${err}`)
          return ''
      }
    }

    ngOnDestroy() {
        document.querySelector('informo-real-time-legend').classList.remove('hidden');
        (<HTMLElement>document.querySelector('app-real-time-menu')).style.display = 'initial';

    }
}

// Aux
function addQueryParams(url, queryParams) {
  const queryString = Object.keys(queryParams)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
    .join('&');
  
  return `${url}${url.includes('?') ? '&' : '?'}${queryString}`;
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/plates-searcher/plates-searcher.component.ts